export const ForgotPassword = {
	title: "Glemt adgangskode",
	explanation_text: "Indtast din e-mailadresse, så sender vi dig instruktioner til at nulstille din adgangskode.",
	button_text: "Send nulstillingsinstruktioner",
	button_loading_text: "Sender nulstillingsinstruktioner...",
	remember_password_text: "Kan du huske din adgangskode?",
	login_button_text: "Log ind",
	success_title: "Nulstillingsinstruktioner sendt!",
	success_explanation_text: `
        Hvis din e-mail findes i vores system, vil du modtage instruktioner til at nulstille din adgangskode.
        Tjek venligst din e-mail, og følg trinene.
    `,
};
